<template>
  <div class="result" v-loading="showLoading">
    <!-- <div class="store_name">{{activeName}}</div> -->
    <div class="url_line">分享地址
      <el-input v-model="activePath" disabled class="url_input" size="small"></el-input>
      <el-button class="ml10" type="text" size="medium"
        v-clipboard:copy="activePath"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError">复制</el-button>
    </div>
    <div class="code_box">
      <div class="title">活动二维码</div>
      <div class="title_des">下载活动二维码并打印，通过扫码让更多用户参与活动</div>
      <div class="code">
        <!-- <div class="qrcode_box" id="qrcode" ref="qrcode"></div> -->
        <img class="qrcode_box" :src="url" alt="">
      </div>
      <div class="code_text">微信扫一扫，使用小程序</div>
      <el-button @click="downloadQrcode" type="primary">下载二维码</el-button>
      <el-button @click="closeQrcode">关闭</el-button>
    </div>
  </div>
</template>
<script>
import VueClipboard from "vue-clipboard2";
import QRCode from "qrcodejs2";
import { mapGetters } from "vuex"
import { inviteQrcode } from "@/api/market"
export default {
  props: {
    id: {
      type: String,
      default: "",
    }
  },
  watch: {
    id:{
      handler(val){
        console.log("result_form =====================",val)
        this.getUrl()
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
      url: "",
      activeName: "",
      activePath: "",
      showLoading: false,
    }
  },
  mounted(){
    // this.crateQrcode();
  },
  methods:{
    getUrl(){
      this.showLoading = true
      if(this.id){
        inviteQrcode({app_id: this.app_id, id: this.id}).then(res => {
          if(res.code == 200) {
            this.url = res.data.qrcode;
            this.activeName = res.data.name;
            this.activePath = res.data.path;
            // this.createQrcode();
          }else{
            this.$message('网络错误，请稍后重试')
          }
          this.showLoading = false;
        })
      }
    },
    nextStep(){
      this.$emit('nextStep')
    },
    lastStep(){
      this.$emit('lastStep')
    },
    onCopy(){
      this.$message({
        type: "success",
        message: "复制成功"
      })
    },
    onError(){
      this.$message({
        type: "error",
        message: "复制失败，请手动选择复制"
      })
    },
    // 生成二维码
    createQrcode() {
      var canvas = this.$refs.qrcode;
      new QRCode(canvas, {
        width: 150,
        height: 150,
        text: this.url // 二维码内容
      });
    },
    downloadQrcode(){
      var linkUrl = localStorage.getItem('baseStatus') == 'test'? "https://cs.58zltc.com/":"https://www.58zltc.com/";
      linkUrl += "manage/activity.invite/downLoadInvite" + 
        "?token=" + this.token +
        "&app_id=" + this.app_id +
        "&id=" + this.id;
      window.location.href = linkUrl;
    },
    closeQrcode(){
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.result{
  text-align: center;
}
.store_name{
  margin: 30px 0 12px 0;
}
.url_line{
  color: #666;
  .url_input{
    width: 480px;
    margin: 0 5px;
  }
}
.code_box{
  margin: 20px auto;
  width: 600px;
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 26px 20px;
  .title{
    font-size: 18px;
    font-weight: 700;
    text-align: left;
  }
  .title_des{
    text-align: left;
    font-size: 13px;
    margin-top: 16px;
  }
  .code{
    margin:30px auto 10px auto;
    width: 172px;
    height: 172px;
    padding: 5px;
    border: 1px solid #eee;
  }
  .code_text{
    margin-bottom: 40px;
  }
  .qrcode_box{
    width: 160px;
    height: 160px;
  }
}
</style>